import React from "react";
import { Button, Result } from "antd";
import { useNavigate } from "react-router-dom";

const PublicPageNotFound = () => {
  const navigate = useNavigate();

  return (
    <div style={{ height: "100vh", display: "flex", alignItems: "center", justifyContent: "center", backgroundColor: "#f0f2f5" }}>
      <Result
        status="404"
        title="404"
        subTitle="Sorry, the page you visited does not exist."
      />
    </div>
  );
};

export default PublicPageNotFound;
